export default __webpack_public_path__ + "static/media/portrait--phil.9a3e8cde.jpg";